import { render, staticRenderFns } from "./updateUserInfo.vue?vue&type=template&id=ebab0fce&scoped=true&"
import script from "./updateUserInfo.vue?vue&type=script&lang=js&"
export * from "./updateUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./updateUserInfo.vue?vue&type=style&index=0&id=ebab0fce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebab0fce",
  null
  
)

export default component.exports